import { useEffect, useRef } from "react";

/** Kiosk inactivity reset: after `seconds` without a touch/click/key, clear
 *  any selection/route and return the map to its home view. The surrounding
 *  kiosk shell (sitummap-visualizer) handles screensaver carousels; this only
 *  resets the map state so the next visitor starts clean. */
export default function IdleReset({ seconds = 90, onIdle }) {
  const timerRef = useRef(null);
  const onIdleRef = useRef(onIdle);
  onIdleRef.current = onIdle;

  useEffect(() => {
    const rearm = () => {
      clearTimeout(timerRef.current);
      timerRef.current = setTimeout(() => onIdleRef.current?.(), seconds * 1000);
    };
    const events = ["pointerdown", "touchstart", "keydown", "wheel"];
    events.forEach((name) => window.addEventListener(name, rearm, { passive: true }));
    rearm();
    return () => {
      clearTimeout(timerRef.current);
      events.forEach((name) => window.removeEventListener(name, rearm));
    };
  }, [seconds]);

  return null;
}
